module.exports = __webpack_public_path__ + "assets/4c9bee1ce6d0f15d9f5b95131390c9b8.png";